module.exports = __webpack_public_path__ + "static/media/APP-LOGIN-2.94eee539.jpg";